<template>
  <div>
    <div ref="echart" class="chart-container"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "TemperatureChart",
  props: {
    xdata: {
      type: Array,
      required: true,
    },
    ydata: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.initChart();
    window.addEventListener("resize", this.resizeChart);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeChart);
  },
  watch: {
    xdata: "updateChart",
    ydata: "updateChart",
  },
  methods: {
    initChart() {
      this.myChart = echarts.init(this.$refs.echart);
      this.updateChart();
    },
    updateChart() {
      const colors = ['#3398DB', '#00FF00', '#FF5733', '#FFC300']; // 颜色数组
      const seriesNames = ['Highest', 'Lowest', 'Average', 'Minimum']; // 数据集名称

      const option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          bottom: 0,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xdata,
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false, // 隐藏左侧刻度线
          },
          splitLine: {
            lineStyle: {
              type: 'dashed', // 设置为虚线
            },
          },
          axisTick: {
            show: false, // 隐藏刻度线
          },
        },
        series: this.ydata.map((data, index) => ({
          name: seriesNames[index] || `Data ${index + 1}`, // 获取名称
          type: "line",
          data: data,
          itemStyle: {
            color: colors[index % colors.length], // 循环使用颜色
          },
          markPoint: {
            data: [
              { type: "max", name: "Max" },
              { type: "min", name: "Min" },
            ],
          },
        })),
      };

      this.myChart.setOption(option);
    },
    resizeChart() {
      if (this.myChart) {
        this.myChart.resize();
      }
    },
  },
};
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 400px;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
</style>
